import { useEffect, useRef } from 'react';
import { Balloons, BalloonsRef } from '@/components/ui/balloons';

interface ReservationSuccessAnimationProps {
  onComplete?: () => void;
}

export const ReservationSuccessAnimation = ({ onComplete }: ReservationSuccessAnimationProps) => {
  const castleRef = useRef<HTMLDivElement>(null);
  const balloonsRef = useRef<BalloonsRef>(null);

  useEffect(() => {
    const timeouts: ReturnType<typeof setTimeout>[] = [];

    // Launch balloons animation
    timeouts.push(setTimeout(() => {
      balloonsRef.current?.launchAnimation();
    }, 200));

    // Castle animation
    timeouts.push(setTimeout(() => {
      if (castleRef.current) castleRef.current.classList.add('animate-castle-enter');
    }, 500));

    // Auto-dismiss
    timeouts.push(setTimeout(() => onComplete?.(), 6000));

    return () => timeouts.forEach(clearTimeout);
  }, [onComplete]);

  return (
    <>
      <Balloons ref={balloonsRef} type="default" />
      <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[9999] p-4">
        <div className="bg-white rounded-2xl p-8 text-center max-w-md w-full shadow-2xl animate-scale-in">
          <div 
            ref={castleRef} 
            className="text-8xl mb-6 scale-[0.3] opacity-0 transition-all duration-[1500ms] ease-[cubic-bezier(0.68,-0.55,0.265,1.55)]"
          >
            🏰
          </div>
          <h2 className="text-2xl font-bold text-primary mb-4 animate-pulse">
            Demande envoyée !
          </h2>
          <p className="text-muted-foreground">
            Nous avons bien reçu votre demande de réservation. 
            Vous recevrez une confirmation par email très bientôt !
          </p>
        </div>
      </div>
    </>
  );
};
